<div [formGroup]="form" *ngIf="form">
    <div class="row">
        <ng-container>
            <div class="form-group col-lg-6">
                <label>{{'administration.sectionsManagement.code' | translate}} *</label>
                <apc-form-input [class]="'form-control'" formControlName="code" type="text">
                </apc-form-input>
            </div>
        </ng-container>
        <div class="form-group col-lg-6">
            <label>{{'administration.sectionsManagement.value' | translate}} *</label>
            <apc-form-input [class]="'form-control'" formControlName="name" type="text"></apc-form-input>
        </div>
    </div>
</div>